export const SEND_ACK_DEFAULT_TIMEOUT = 20000;
export let MessageAckStatus;
(function (MessageAckStatus) {
  MessageAckStatus["MESSAGE_RECIEVED"] = "MESSAGE_RECIEVED";
  MessageAckStatus["MESSAGE_TIMEOUT"] = "MESSAGE_TIMEOUT";
  MessageAckStatus["MESSAGE_ERROR"] = "MESSAGE_ERROR";
})(MessageAckStatus || (MessageAckStatus = {}));
export function isMessageReceived(promiseResult) {
  return promiseResult.status === MessageAckStatus.MESSAGE_RECIEVED;
}
export function sendMessageAndAck({
  port,
  inboundPort,
  message,
  errorAckMessageType,
  timeout
}) {
  return new Promise(resolve => {
    if (!message.type || !message.originConnectionId || !message.responseRequest || !message.responseRequest.type) {
      resolve({
        status: MessageAckStatus.MESSAGE_ERROR,
        responseMessageType: message && message.responseRequest && message.responseRequest.type || 'unknown',
        errorMessage: `sendMessageAndAck requires a type an originConnectionId and responseRequest info, recieved: ${message.type}, ${message.originConnectionId}`
      });
      return;
    }
    const responseMessageType = message.responseRequest.type;
    let errorReason = `sendMessageAndAck never received response message type ${responseMessageType}`;
    let messageTimeout;
    if (!inboundPort) inboundPort = port;
    const messageListener = messageEvent => {
      const hasMessageEventData = Boolean(messageEvent.data);
      const isExpectedResponseType = hasMessageEventData && (messageEvent.data.type === responseMessageType || errorAckMessageType && messageEvent.data.type === errorAckMessageType);
      if (!isExpectedResponseType) {
        errorReason = `sendMessageAndAck never received response message type ${responseMessageType}, Last message type is ${messageEvent.data && messageEvent.data.type || 'unknown'}`;
        return;
      } else if (messageEvent.data.responseRequest.requestId === message.id && messageEvent.data.destinationConnectionId === message.originConnectionId) {
        if (inboundPort) inboundPort.removeEventListener('message', messageListener);
        clearTimeout(messageTimeout);
        if (messageEvent.data.type === errorAckMessageType) {
          resolve({
            status: MessageAckStatus.MESSAGE_ERROR,
            responseMessageType,
            messageEvent
          });
          return;
        }
        resolve({
          status: MessageAckStatus.MESSAGE_RECIEVED,
          responseMessageType,
          messageEvent
        });
        return;
      }
      errorReason = `sendMessageAndAck recieved Message ${responseMessageType} with non-matching requestId: ${messageEvent.data.responseRequest.requestId !== message.id} or connectionId: ${messageEvent.data.destinationConnectionId !== message.originConnectionId} error`;
    };
    inboundPort.addEventListener('message', messageListener);
    try {
      port.postMessage(message);
      messageTimeout = setTimeout(() => {
        if (inboundPort) inboundPort.removeEventListener('message', messageListener);
        resolve({
          status: MessageAckStatus.MESSAGE_TIMEOUT,
          responseMessageType,
          errorMessage: errorReason
        });
      }, typeof timeout === 'number' ? timeout : SEND_ACK_DEFAULT_TIMEOUT);
    } catch (e) {
      if (inboundPort) inboundPort.removeEventListener('message', messageListener);
      clearTimeout(messageTimeout);
      resolve({
        status: MessageAckStatus.MESSAGE_ERROR,
        responseMessageType,
        errorMessage: `Failed to send postMessage for sync message ${message.type} reason: ${e.message}`
      });
      return;
    }
  });
}